import { useTranslation } from 'react-i18next';
import { forwardRef } from 'react';
import { useState, useEffect } from 'react';
import { Select, MenuItem, Checkbox, Box, Chip, ListItemText } from '@mui/material';
import API from '@utils/axios';
import { extractBestTranslation } from '@/utils/helpers';

const WorkflowSelect = forwardRef(({ emptyLabel, ...params }, ref) => {
    const { i18n } = useTranslation();
    const [workflows, setWorkflows] = useState([]);

    useEffect(() => {
        const fetchWorkflows = async () => {
            try {
                const response = await API.get('/workflows', {
                    params: {
                        sort: 'name',
                        direction: 'asc',
                        per_page: 9999,
                    }
                });
                if (response.data && Array.isArray(response.data.data)) {
                    setWorkflows(response.data.data);
                } else {
                    setWorkflows([]);
                }
            } catch (error) {
                setWorkflows([]);
            }
        };
        fetchWorkflows();
    }, []); // Pas de dépendance, donc le code s'exécute une seule fois

    return (
        params.multiple ? (
            <Select ref={ref} {...params}
                renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map((value) => {
                            const workflow = workflows.find((workflow) => workflow.id === value);
                            if (!workflow) return null;
                            return (
                                <Chip label={extractBestTranslation(workflow.name, i18n.language)} key={value} size="small" />
                            );
                        })}
                    </Box>
                )}
            >
                {workflows.map((workflow) => (
                    <MenuItem key={workflow.id} value={workflow.id}>
                        {<Checkbox checked={params.value.indexOf(workflow.id) > -1} />}
                        <ListItemText>{extractBestTranslation(workflow.name, i18n.language)}</ListItemText>
                    </MenuItem>
                ))}
            </Select>
        ) : (
            <Select ref={ref} {...params}>
                {emptyLabel && <MenuItem value="">{emptyLabel}</MenuItem>}
                {workflows.map((workflow) => (
                    <MenuItem key={workflow.id} value={workflow.id}>
                        <ListItemText>{extractBestTranslation(workflow.name, i18n.language)}</ListItemText>
                    </MenuItem>
                ))}
            </Select>
        )
    );
});

export default WorkflowSelect;